export type ConnectorType = 'GitHub' | 'GitLab' | 'Bitbucket' | 'AzureDevOps' | 'Jira' | 'Figma' | 'SonarQube' | 'RelationalDatabase' | 'Anthropic' | 'GitHubCopilot' | 'QubizTitan'

export type ConnectorCategory = 'SourceControl' | 'Database' | 'IssueTracker' | 'Design' | 'CodeQuality' | 'AiProvider'

export interface Connector {
  id: string
  type: ConnectorType
  category: ConnectorCategory
  providerMetadata: string | null
}

export interface ProviderRepositoryInfo {
  id: string
  name: string
  fullName: string
  url: string | null
  isPrivate: boolean
}

export interface AzureDevOpsProjectInfo {
  id: string
  name: string
}

export interface WikiInfo {
  id: string
  name: string
}

export interface WikiListItem {
  project: string
  id: string
  name: string
}

export interface WikiPageNode {
  path: string
  remoteUrl: string | null
  subPages: WikiPageNode[]
}

export interface ProviderBranchInfo {
  name: string
  isDefault: boolean
}

export interface ProviderFileInfo {
  path: string
  name: string
}

export interface SaveTokenRequest {
  token: string
  email?: string
  site?: string
}

export interface SaveTokenResponse {
  projectId: string
  connectorType: string
}

export interface TitanEndpointStatus {
  configured: boolean
}

export interface DeviceFlowInitiation {
  flowId: string
  userCode: string
  verificationUri: string
  expiresIn: number
  interval: number
}

export interface DeviceFlowPollResult {
  status: 'Pending' | 'Complete' | 'SlowDown' | 'Expired' | 'AccessDenied' | 'Error'
  nextPollIntervalSeconds?: number
  error?: string
}

export const DATABASE_ENGINES = [
  'postgresql',
  'cockroachdb',
  'mysql',
  'mariadb',
  'sqlserver',
  'cloud-sql-mssql',
  'oracle',
  'sqlite',
  'openedge',
] as const

export const FILE_BASED_ENGINES: readonly string[] = ['sqlite', 'openedge']

export type DatabaseEngine = (typeof DATABASE_ENGINES)[number]

export const DATABASE_ENCRYPT_MODES = ['true', 'disable'] as const

export type DatabaseEncryptMode = (typeof DATABASE_ENCRYPT_MODES)[number]

export interface DatabaseConnectorMetadata {
  dbType: string
  host: string
  port?: string | null
  database: string
  user: string
  encrypt?: string | null
  fileBlobPath?: string | null
  fileName?: string | null
}

export interface SaveDatabaseConnectorRequest {
  connectorId?: string | null
  dbType: string
  host: string
  port?: string | null
  database: string
  user: string
  password: string
  encrypt?: string | null
  fileBlobPath?: string | null
  fileName?: string | null
}

export interface SaveDatabaseConnectorResponse {
  projectId: string
  connectorId: string
  connectorType: string
}

export interface SonarQubeConnection {
  id: string
  connectionName: string
  serverUrl: string
  projectName: string | null
  projectKey: string
}

export interface CreateSonarQubeConnectionResponse {
  id: string
}

export interface SaveSonarQubeConnectionRequest {
  connectionName: string
  serverUrl: string
  projectName?: string
  projectKey: string
  accessToken?: string
}

export interface TestSonarQubeConnectionRequest {
  serverUrl: string
  projectKey: string
  accessToken?: string
}
